import { Component } from '@angular/core';
import { EmperorUIButtonTypes } from '@boldpenguin/emperor-presentational';
import { LocalStorageService } from 'ngx-webstorage';
import {
  MixpanelEventType,
  MixpanelService,
} from 'src/app/core/services/mixpanel-service/mixpanel.service';

export const compatibilityBannerLocalStorage = 'compat-banner-dismissed';

@Component({
  selector: 'app-compatibility-banner',
  templateUrl: './compatibility-banner.component.html',
  styleUrls: ['./compatibility-banner.component.scss'],
})
export class CompatibilityBannerComponent {
  readonly emperorTextButton = EmperorUIButtonTypes.Text;

  constructor(
    private mixpanelService: MixpanelService,
    private localSt: LocalStorageService,
  ) {}

  dismiss() {
    this.localSt.store(compatibilityBannerLocalStorage, true);
    this.mixpanelService.track(
      MixpanelEventType.COMPATIBILITY_BANNER_DISMISSED,
    );
  }
}
